import React, { useEffect } from 'react';
import { FormLayoutComposer, IFormLayoutProps } from 'components/common/form/renderer/FormLayoutComposer';
import useWatchFormFieldsChanges from 'components/common/form/hooks/useWatchFormFieldsChanges';
import { useQuery } from '@tanstack/react-query';
import { instance } from 'api/api';
import { APIResponse, YNValues } from 'tools/types';

export default function ConciergeForm(props: IFormLayoutProps) {
    useWatchFormFieldsChanges(
        props.hookForm.form,
        [
            'include_content_search_ind',
            'include_help_docs_ind',
            'include_glossary_ind',
            'include_custom_faq_ind',
            'llm_custom_faq_dataset_id',
            'llm_custom_faq_question_column_id',
            'llm_custom_faq_answer_column_id',
            'llm_custom_faq_scope',
            'llm_custom_faq_include_portal_name',
        ],
        'update_index_alert_front_status',
    );
    const isFrontChanges = props.hookForm.form.hookFormWatch('update_index_alert_front_status') == 'Y';
    const { data } = useQuery<boolean, Error>({
        queryKey: ['ConciergeIndexAlert'],
        queryFn: async () => {
            const result = await instance.get<APIResponse<{ reindex_required_ind: YNValues }>>(
                'data/admin/concierge/check-reindex-needed',
            );
            return result.data.status == 'OK' && result.data.data.reindex_required_ind == 'Y';
        },
        refetchOnMount: 'always',
    });

    useEffect(() => {
        props.hookForm.form.hookFormSetValue('update_index_alert_status', data || isFrontChanges ? 'Y' : 'N');
    }, [data, isFrontChanges]);

    return <FormLayoutComposer props={{ ...props }} />;
}
